import * as Api from './api';

export class PersonClient {
  personId: number;

  constructor(personId: number) {
    this.personId = personId;
  }

  update = (update: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
  }) =>
    Api.post(`/person/${this.personId}`, {
      body: JSON.stringify({
        person: update,
      }),
    });
}
